import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Privacy from './components/Privacy';
import InstallPWA from './components/InstallPWA';

function App() {
  return (
    <>
      <InstallPWA />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </>
  );
}

export default App;